"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Pill = exports.TagInput = void 0;
const TextInput_1 = require("../TextInput/TextInput");
const react_1 = __importStar(require("react"));
const Theme_1 = require("../../Theme/Theme");
const Icon_1 = __importDefault(require("../Icon/Icon"));
const MultiSelectMenu_1 = require("../Menus/MultiSelectMenu");
// Main Wrapping Component
const TagInput = (_a) => {
    var { onPillsChange, id = 'tagInput' } = _a, props = __rest(_a, ["onPillsChange", "id"]);
    return (react_1.default.createElement(TextInput_1.TextInput, Object.assign({}, props, { id: id, autoComplete: false, inputComponent: react_1.default.createElement(PillBoxInput, Object.assign({ onPillsChange: onPillsChange, id: id }, props)) })));
};
exports.TagInput = TagInput;
// Main internal component
const PillBoxInput = (_a) => {
    var { onPillsChange, label, initialPills = [], searchablePills = [], disabled } = _a, props = __rest(_a, ["onPillsChange", "label", "initialPills", "searchablePills", "disabled"]);
    // State
    const [pills, setPills] = (0, react_1.useState)(initialPills);
    const [padding, setPadding] = (0, react_1.useState)();
    const [inputValue, setInputValue] = (0, react_1.useState)(initialPills.length > 0 ? ' ' : '');
    const [menuOpen, setMenuOpen] = (0, react_1.useState)(false);
    const [searchable, setSearchable] = (0, react_1.useState)(parseSearchablePills(searchablePills, initialPills));
    const pillsRef = (0, react_1.useRef)(null);
    (0, react_1.useEffect)(() => {
        setPills(initialPills);
    }, [initialPills.length]);
    // Side Effects
    (0, react_1.useEffect)(() => {
        // Move Cursor in front of pills
        if (pillsRef.current && pills.length > 0) {
            setPadding(pillsRef.current.clientWidth + 10);
        }
        else {
            setPadding(0);
        }
        // Set searchable tags checked
        const newSearchable = searchable.map(({ text }) => ({
            text,
            checked: pills.some((el) => el === text),
        }));
        setSearchable(newSearchable);
        onPillsChange && onPillsChange(pills);
        // control label animation
        if (pills.length > 0) {
            setInputValue(' '); // Hold input open
        }
        else {
            setInputValue('');
        }
    }, [pills.length]);
    // Handlers
    const onTextChange = ({ target: { value }, }) => {
        if (`${value}`.includes(',')) {
            //Reverse to get last, and value user might still be working on
            const [newValue, ...newPills] = `${value}`
                .toLowerCase()
                .split(',')
                .reverse();
            const dedupedPills = Array.from(new Set([...pills, ...newPills.map((el) => el.trim()).reverse()]));
            // Reverse back to get correct order;
            setPills(dedupedPills);
            // Maintain current working state.
            setInputValue(newValue.length === 0 && pills.length > 0 ? ' ' : newValue);
            return;
        }
        // Filter down searchable results
        if (value.trim().length > 0) {
            const trimmedValue = value.trim().toLowerCase();
            const fuzzySearch = new RegExp(`^${trimmedValue}.*$`);
            const filteredSearchable = searchablePills.filter((text) => fuzzySearch.test(text));
            const newSearchable = parseSearchablePills(filteredSearchable, pills);
            setSearchable(newSearchable);
        }
        else {
            setSearchable(parseSearchablePills(searchablePills, pills));
        }
        setInputValue(value);
    };
    const onDeleteClicked = (key) => () => {
        if (disabled)
            return;
        if (pills.length === 1) {
            setPills([]);
            return;
        }
        setPills(pills.filter((el) => {
            return el !== key;
        }));
    };
    const onKeyDownHandler = (0, react_1.useCallback)((_a) => {
        var _b;
        var { key, code, target } = _a, event = __rest(_a, ["key", "code", "target"]);
        const targetAlias = target;
        if ((key === 'Enter' ||
            code === 'Enter' ||
            code === 'Space' ||
            key === 'Space') &&
            inputValue.trim().length > 0) {
            onTextChange(Object.assign({ target: Object.assign(Object.assign({}, targetAlias), { value: `${targetAlias.value.trim()},` }) }, event));
            setSearchable(parseSearchablePills(searchablePills, pills));
        }
        if ((key === 'Backspace' || code === 'Backspace') &&
            inputValue.trim().length === 0) {
            const last = (_b = [...pills].pop()) !== null && _b !== void 0 ? _b : '';
            onDeleteClicked(last)();
            setSearchable(parseSearchablePills(searchablePills, pills));
            return;
        }
    }, [inputValue, pills.length]);
    const inputOnFocus = (event) => {
        setMenuOpen(searchablePills.length > 0);
        if (pills.length > 0 && inputValue.trim().length === 0) {
            setInputValue(''); // Hold input open
        }
        props.onFocus && props.onFocus(event);
    };
    const inputOnBlur = (event) => {
        setMenuOpen(false);
        if (pills.length > 0 && inputValue.trim().length === 0) {
            setInputValue(' '); // Hold input open
        }
        else if (inputValue.trim().length === 0) {
            setInputValue('');
        }
        props.onBlur && props.onBlur(event);
    };
    const onOptionSelected = (option, result) => {
        if (result === 'added') {
            onTextChange({ target: { value: `${option},` } });
        }
        if (result === 'removed') {
            onDeleteClicked(option)();
        }
        setSearchable(parseSearchablePills(searchablePills, pills));
    };
    // UI
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(Input, Object.assign({}, props, { type: "text", className: 'form__field', "data-testid": "text-input", style: { paddingLeft: `${padding}px` }, disabled: disabled, onChange: onTextChange, placeholder: label, value: inputValue, label: label, id: props.id, autoComplete: "off", onKeyDownCapture: onKeyDownHandler, onBlur: inputOnBlur, onFocus: inputOnFocus })),
        react_1.default.createElement(PillWrapper, null,
            react_1.default.createElement(Pills, { ref: pillsRef, label: label }, pills.map((pill, index) => (react_1.default.createElement(exports.Pill, { key: index, pill: pill, onClose: onDeleteClicked(pill) })))),
            menuOpen && searchable.length > 0 && (react_1.default.createElement(MultiSelectMenu_1.MultiSelectContainer, { menuOptions: searchable, onOptionSelected: onOptionSelected, menuLocation: "below", width: "100%", topOffSet: "18px", "data-testid": "multi-select" })))));
};
// Sub components
const Pill = ({ pill, onClose, }) => {
    return (react_1.default.createElement(PillSpan, null,
        pill,
        react_1.default.createElement(Icon_1.default, { "data-testId": `delete-pill-${pill}`, size: "11", icon: "closeBlue", onClick: onClose })));
};
exports.Pill = Pill;
const PillWrapper = Theme_1.styled.div `
  display: flex;
`;
const Pills = Theme_1.styled.div `
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  column-gap: 5px;
  position: absolute;
  top: ${(props) => (props.label ? '22px' : '20tpx')};
`;
const Input = Theme_1.styled.input `
  font-family: inherit;
  width: 100%;
  width: -moz-available;
  width: -webkit-fill-available;
  width: fill-available;
  border: 0;
  outline: 0;
  font-size: 16px;
  color: ${(props) => props.theme.gray2};
  cursor: inherit;
  background: transparent;
  transition: border-color 0.2s;
  position: absolute;
  top: ${(props) => (props.label ? '21px' : '16px')};
`;
const PillSpan = Theme_1.styled.span `
  display: flex;
  flex-direction: row;
  background-color: #eaf7ff;
  border-radius: 15px;
  justify-content: center;
  align-items: center;
  font-size: 12px;
  padding: 2px 10px;
  column-gap: 4px;
  text-transform: capitalize;
`;
// Util Functions
const parseSearchablePills = (searchablePills, pills) => searchablePills.map((text) => ({ text, checked: pills.includes(text) }));
//# sourceMappingURL=TagInput.js.map